import { ENVIRONMENT } from "../../constants"
/* eslint-disable import/prefer-default-export */
// Remove eslint comment above if we add more actions (as expected)

// todo: Not implemented yet
export function loadDummyData(boxIndex, pageIndex) {
  return {
    type: "_PERFORMANCE_PROGRESSION_DUMMY_9BG_DRILLDOWN_DATA",
    boxIndex,
    pageIndex,
  }
}

export function loadData(type, apiUrl, filterLocations) {
  if (filterLocations && filterLocations.length > 0) {
    return {
      type,
      payload: {
        request: {
          method: "PUT",
          url: apiUrl,
          data: { LocationIds: filterLocations },
        },
      },
    }
  }

  return {
    type,
    payload: {
      request: {
        url: apiUrl,
      },
    },
  }
}

export function load9BGDetail(
  boxIndex,
  pageNumber,
  pageSize,
  reloadBox,
  filterParamsQueryString,
  filterLocations,
  dashboard,
  orderByColumn
) {
  if (!ENVIRONMENT.useDummyData()) {
    let apiUrl = "/reporting/succession-planning/details"

    // Append the filter parameters as the query string
    apiUrl += filterParamsQueryString
    // Have set some initial defaults here but these should probably become constants or variables
    //  passed in as they may differ if we have to show drill on large and small 9BG.
    apiUrl += `&boxIndex=${boxIndex}&pageSize=${pageSize}&pageNumber=${pageNumber}&column=${orderByColumn}`

    // Hits the API to load the data, then returns a Promise
    // (for callback-like functionality - e.g. to load other dashboards in the background)
    // Dashboard specific reducers then hook into the SUCCESS/FAIL action types
    // generated by redux-axios-middleware
    if (reloadBox) {
      return loadData(`${dashboard}LOAD_9BG_DRILLDOWN_BOX`, apiUrl, filterLocations)
    }
    return loadData(`${dashboard}LOAD_9BG_DRILLDOWN`, apiUrl, filterLocations)
  }

  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(loadDummyData(boxIndex, pageNumber))
      resolve()
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/nineBoxGridDrilldownActions.js